import React, { FC } from "react";

import { IPortfolio } from "../../../../state";
import styles from "../PortfolioPreview.module.scss";

type Props = {
  portfolio: IPortfolio;
};

const OnePagePortfolioAssessment: FC<Props> = ({ portfolio }) => {
  const title =
    portfolio.one_page_portfolio_assessments?.[0]
      ?.one_page_portfolio_assessment_issues[0]
      ?.one_page_portfolio_assessment_questions[0].title ?? "";

  const beforeWorksAnswers =
    portfolio.one_page_portfolio_assessments?.[0]
      ?.one_page_portfolio_assessment_issues[0]
      ?.one_page_portfolio_assessment_questions[0]
      ?.one_page_portfolio_assessment_answer?.contents ?? "";

  const afterWorksAnswers =
    portfolio.one_page_portfolio_assessments?.[1]
      ?.one_page_portfolio_assessment_issues?.[0]
      ?.one_page_portfolio_assessment_questions?.[0]
      ?.one_page_portfolio_assessment_answer?.contents ?? "";

  const comparisonAnswers =
    portfolio.one_page_portfolio_assessments?.[1]
      ?.one_page_portfolio_assessment_issues?.[1]
      ?.one_page_portfolio_assessment_questions?.[0]
      ?.one_page_portfolio_assessment_answer?.contents ?? "";

  return (
    <div className={styles.content}>
      <p className={styles.title}>{title}</p>
      <ul className={styles.list}>
        <li className={styles.item}>
          <p className={styles.heading}>学習前</p>
          <p className={styles.text}>{beforeWorksAnswers}</p>
        </li>
        <li className={styles.item}>
          <p className={styles.heading}>学習後</p>
          <p className={styles.text}>{afterWorksAnswers}</p>
        </li>
        <li className={styles.item}>
          <p className={styles.heading}>学習前と学習後を比べて感じたこと</p>
          <p className={styles.text}>{comparisonAnswers}</p>
        </li>
      </ul>
    </div>
  );
};

export default OnePagePortfolioAssessment;
